<template>
    <v-container fluid>
        <template v-if="!isInit">
            <v-progress-linear
                indeterminate
            ></v-progress-linear>
        </template>
        <template v-else>
            <h1>{{ term.termsName }}</h1>

            <v-card flat>
                <v-progress-linear
                    v-if="isLoading"
                    indeterminate
                ></v-progress-linear>
                <template v-else>
                    <v-card flat>
                        <v-card-text class="pa-0" v-if="previewContents">
                            <div class="markdown-preview" v-html="previewContents"></div>
                        </v-card-text>
                        <v-card-text class="pa-0 text-center" v-else>
                            약관을 찾을 수 없습니다.
                        </v-card-text>
                    </v-card>
                </template>
            </v-card>

            <v-footer app
                      fixed
                      outlined
                      height="50"
                      color="#fff"
                      class="px-2 justify-center"
            >
                <v-row justify="end" align="center" no-gutters>
                    <v-col cols="auto">
                        <v-btn
                            depressed
                            width="100"
                            class="secondary-btn"
                            @click="$router.go(-1)"
                        >
                            뒤로
                        </v-btn>
                    </v-col>
                </v-row>
            </v-footer>
        </template>
    </v-container>
</template>

<script>
import "@/assets/css/markdown.css";
import {marked} from 'marked'
import TermsMixin from "@/pages/home/views/apply/TermsMixin";

// Set options
marked.use({
  async: true,
  pedantic: false,
  gfm: true,
});

export default {
    name: 'TermViewer',
    mixins: [TermsMixin],

    data: () => ({
        isInit: false,
        isLoading: false,
        marked: marked,
        termsId: null,
        term: null,
        privacyPolicy: null,
        previewContents: null,
    }),

    async created() {
        this.termsId = this.$route.params.termsId;
        await this.fetchTerm(this.termsId);
    },

    methods: {
        async fetchTerm() {
            this.isLoading = true;
            try {
                this.term = await this.findTerm(this.termsId)
                if (this.term?.contents) {
                    this.previewContents = await marked.parse(this.term.contents);
                }
            } catch(err) {
                console.error(err);
            } finally {
                this.isLoading = false;
                this.isInit = true;
            }
        }
    }


}
</script>

<style scoped>
h1 {
    font-size: 1.666rem;
    font-weight: 600;
    text-align: center;
    margin: 1rem 0 2rem;
}
</style>